var map = {
	"./fastener-placement-rectangle-1-break.webp": 99,
	"./fastener-placement-rectangle-2-breaks.webp": 100,
	"./fastener-placement-rectangle-3-breaks.webp": 101,
	"./fastener-placement-rectangle-rounded-back.webp": 102,
	"./fastener-placement-rectangle-rounded-bottom.webp": 103,
	"./fastener-placement-rectangle-rounded-corners.webp": 104,
	"./fastener-placement-rectangle-rounded-front.webp": 105,
	"./fastener-placement-rectangle-rounded-top.webp": 106,
	"./fastener-placement-rectangle-squared-corners.webp": 107,
	"./fastener-placement-rectangle-trapezoid-reversed.webp": 108,
	"./fastener-placement-rectangle-trapezoid.webp": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 269;